import React, { useId } from 'react';

const paths = {
  close: 'm6 6 12 12M6 18 18 6',
  expand: 'M8 3H3v5m13-5h5v5M3 16v5h5m13-5v5h-5',
  collapse: 'M3 8h5V3m8 0v5h5M8 21v-5H3m13 5v-5h5',
  history: 'M3 11a9 9 0 1 1 2 7M3 4v7h7m2-4v5l3 2',
  plus: 'M12 5v14M5 12h14',
  arrow: 'M5 12h14m-5-5 5 5-5 5',
  up: 'M12 19V5m-6 6 6-6 6 6',
  down: 'm6 9 6 6 6-6',
  back: 'M19 12H5m5-5-5 5 5 5',
  check: 'm5 12 4 4L19 6',
  search: 'M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
  source: 'M4 4h7v16H4zm9 0h7v16h-7',
  chart: 'M4 20V10m8 10V4m8 16v-7',
  shield: 'm12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6zm-4 9 3 3 5-6',
  stop: 'M6 6h12v12H6z',
  more: 'M4 12h1m6 0h1m6 0h1',
  info: 'M12 11v6m0-10v.1M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0',
  like: 'M8 10v10H4V10zm0 0 4-7c3 0 2 4 2 6h5c2 0 1 6 0 11H8',
  dislike: 'M8 14V4H4v10zm0 0 4 7c3 0 2-4 2-6h5c2 0 1-6 0-11H8',
  trash: 'M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7',
  clock: 'M12 7v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0',
};
export function Icon({ name, size = 18 }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] || paths.info} /></svg>;
}
export function IconButton({ icon, label, className = '', ...props }) {
  return <button type="button" className={'o-btn o-btn-ghost aiw-icon-button ' + className} aria-label={label} title={label} {...props}><Icon name={icon} /></button>;
}
// Same compact Orbit mark geometry as the existing favicon, with stylesheet tokens.
// Inline SVG lets the live workspace and isolated previews share the same mark.
export function Mark({ large = false }) {
  const id = useId();
  return <svg className={large ? 'aiw-mark aiw-mark-large' : 'aiw-mark'} viewBox="0 0 64 64" aria-hidden="true">
    <defs><clipPath id={id}><rect x="-32" y="32" width="128" height="64" transform="rotate(-30.5 32 32)" /></clipPath></defs>
    <ellipse cx="32" cy="32" rx="30.2" ry="6.8" fill="none" stroke="var(--brass-lift)" strokeWidth="4.2" transform="rotate(-30.5 32 32)" />
    <circle cx="32" cy="32" r="20.9" fill="var(--aiw-mark-body, var(--ink))" />
    <g clipPath={'url(#' + id + ')'}>
      <ellipse cx="32" cy="32" rx="30.2" ry="6.8" fill="none" stroke="var(--aiw-mark-gap, var(--surface))" strokeWidth="5.8" transform="rotate(-30.5 32 32)" />
      <ellipse cx="32" cy="32" rx="30.2" ry="6.8" fill="none" stroke="var(--brass-lift)" strokeWidth="4.2" transform="rotate(-30.5 32 32)" />
    </g>
  </svg>;
}
